import React, { forwardRef, useCallback, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import Toggle, { ToggleProps } from 'src/Components/toggle/Toggle'

/**
 * Formik Toggle needed to use formik context and validation for a Toggle button
 */
const SwitchField = forwardRef<typeof Toggle, ToggleProps>((props, ref) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(props.name as string)
  const isActive = useMemo(() => field.value, [field.value])

  const handleChangeEvent = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (props.name) {
        setFieldValue(props.name, event.target.checked)
      } else {
        console.warn('Invalid fieldName', props.name)
      }
    },
    [setFieldValue, props.name]
  )

  return <Toggle {...props} checked={isActive} onChange={handleChangeEvent} inputRef={ref} />
})

SwitchField.displayName = 'SwitchField'

export default SwitchField
